import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Typography, Tabs, Table, Button, Spin, Pagination, Select, message, Input, InputNumber, Checkbox, Tooltip, Col, Row, Modal, Form } from "antd";
// import SidebarLayout from "./SidebarLayout";
import SidebarLayout from "../BankerUI/SidebarLayout";
import _BankAdminService from "../../modules/BankAdminService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ButtonComponent from "../../components/Button/Button";
import FormItemSelect from "../../components/FormItems/FormItemSelect";
import CurrencyInput from "../../components/CurrencyInput";
import "../BankerUI/AdvancesAndRepayments.scss";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import {
  CloseOutlined,
  EyeOutlined,
  EditTwoTone,
  SaveTwoTone,
} from "@ant-design/icons";
const { TabPane } = Tabs;
const { Title } = Typography;
const { Option } = Select;

const AdvancesAndRepayments = () => {
  const loginEmail = localStorage.getItem("loginEmail");
  // const bankAdminId = localStorage.getItem("BankAdminId");

  const [selectedSponsorDetails, setSelectedSponsorDetails] = useState(null);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [firmList, setFirmList] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState(null);
  const [loanProgramTypeList, setLoanProgramTypeList] = useState([]);
  const [selectedLoanProgramType, setSelectedLoanProgramType] = useState(null);

  const [drawsData, setDrawsData] = useState([]);
  const [repaymentsData, setRepaymentsData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Right-of-"Choose Credit Facility" last-submitted info, shown per active tab.
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [lastSubmittedByNameAdvance, setLastSubmittedByNameAdvance] = useState(null);
  const [lastSubmittedDateAdvance, setLastSubmittedDateAdvance] = useState(null);
  const [lastSubmittedByNameRepayment, setLastSubmittedByNameRepayment] = useState(null);
  const [lastSubmittedDateRepayment, setLastSubmittedDateRepayment] = useState(null);

  // Row selection (existing Action-column checkbox) for Certify & Submit Batch
  const [selectedAdvanceRowKeys, setSelectedAdvanceRowKeys] = useState([]);
  const [selectedRepaymentRowKeys, setSelectedRepaymentRowKeys] = useState([]);
  const [batchSubmitting, setBatchSubmitting] = useState(false);

  // Certify & Submit Batch popup — collects SubmittedByName (typed) and SubmittedDate
  // (auto-populated on open), both passed through to the existing batch submit API.
  const [certifyModalVisible, setCertifyModalVisible] = useState(false);
  const [certifyBatchType, setCertifyBatchType] = useState(null); // "Advance" | "Repayment"
  const [submittedByName, setSubmittedByName] = useState("");
  const [submittedDate, setSubmittedDate] = useState(null);
  const [certifyForm] = Form.useForm();

  // pagination states
  const [drawsPage, setDrawsPage] = useState(1);
  const [repaymentsPage, setRepaymentsPage] = useState(1);
  const pageSize = 5;

  const bankadminIdRaw = localStorage.getItem("BankAdminId");
  const BankAdminId = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;
  const [BankAdminID, setBankAdminID] = useState(BankAdminId);
  const [editingKey, setEditingKey] = useState(null);
  const [editingRepaymentKey, setEditingRepaymentKey] = useState(null);
  const [editingRow, setEditingRow] = useState({});
  const [editingRepaymentRow, setEditingRepaymentRow] = useState({});

  // Calculation Summary preview — read-only, never touches drawsData/repaymentsData or edit state.
  // Rendered as an expandable row (antd Table `expandable`) instead of a Modal — expandedRowKey holds
  // the ApplicationId of whichever row currently has its calculation panel open (only one at a time).
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [previewTab, setPreviewTab] = useState(null); // "advance" | "repayment"
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewSaving, setPreviewSaving] = useState(false);

  // Transaction History popup — view-only, loaded from ApplicantAdvance/ApplicantRepayment by ApplicationId
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyTab, setHistoryTab] = useState(null); // "advance" | "repayment"

  // Batch History popup — Certify & Submit Batch history, loaded by sponserId + batchType
  const [batchHistoryModalVisible, setBatchHistoryModalVisible] = useState(false);
  const [batchHistoryData, setBatchHistoryData] = useState([]);
  const [batchHistoryLoading, setBatchHistoryLoading] = useState(false);
  const [batchHistoryType, setBatchHistoryType] = useState(null); // "Advance" | "Repayment"
  const [batchHistoryPage, setBatchHistoryPage] = useState(1);

  const [loanProgrameType, setLoanProgrameType] = useState();
  const [totalAvailability, setTotalAvailability] = useState();
  const [totalBorrowingBase, setTotalBorrowingBase] = useState();
  const [totalOutstanding, setTotalOutstanding] = useState();
  const [loanProgramSummary, setLoanProgramSummary] = useState({});

  const firmAdminId = parseInt(localStorage.getItem("ApplicationId"));

  // Tracks whether the Credit Facility list has ever been auto-populated yet — true only for
  // the very first Firm selection (the initial default view). Any Firm change after that is a
  // user-driven change, and must reset Credit Facility to unselected instead of auto-picking one.
  const isInitialFirmLoadRef = useRef(true);

  const getTableEmptyText = () => <div className="table-empty-message">No Data.</div>;

  useEffect(() => {
    if (BankAdminID && loginEmail) {
      getFirmList();
    }
  }, [BankAdminID, loginEmail]);

  // Select Firm -> auto-select the first entry once the list loads.
  useEffect(() => {
    if (!selectedFirm && firmList.length > 0) {
      setSelectedFirm(firmList[0].Id);
    }
  }, [firmList]);

  // Select Credit Facility -> whenever the selected Firm changes, load its Credit Facility
  // list (scoped to this Firm Admin's own assignments) and auto-select the first entry.
  useEffect(() => {
    if (!selectedFirm) {
      setLoanProgramTypeList([]);
      setSelectedLoanProgramType(null);
      return;
    }
    const shouldAutoSelect = isInitialFirmLoadRef.current;
    isInitialFirmLoadRef.current = false;
    (async () => {
      const types = await getLoanProgramTypeList(selectedFirm);
      setLoanProgramTypeList(types);
      if (shouldAutoSelect && types.length > 0) {
        // Each entry is keyed by its own unique SponserId (a firm can have multiple facilities
        // sharing the same LoanProgrameTypeId, differentiated only by Credit Facility Name), so the
        // Select is bound to SponserId while LoanProgrameTypeId is kept separately for type-branching.
        const firstType = types[0];
        setSelectedLoanProgramType(firstType.SponserId);
        setLoanProgrameType(firstType.LoanProgrameTypeId);
        fetchFirmAdminData(selectedFirm, firstType.LoanProgrameTypeId, firstType.SponserId);
      } else {
        setSelectedLoanProgramType(null);
        setLoanProgrameType(null);
        setDrawsData([]);
        setRepaymentsData([]);
      }
    })();
  }, [selectedFirm]);
  useEffect(() => {
    const handleBankAdminIdChange = (e) => {
      const newId = e.detail.newId;
      setBankAdminID(newId);
    };

    window.addEventListener("BankAdminIdChanged", handleBankAdminIdChange);

    return () => {
      window.removeEventListener("BankAdminIdChanged", handleBankAdminIdChange);
    };
  }, []);

  // useEffect(() => {
  //   fetchSponsorList(loginEmail, BankAdminID);
  // }, []);

  // 📌 Fetch sponsor list
  // const fetchSponsorList = async (loginEmail, bankAdminId) => {
  //   try {
  //     setLoading(true);
  //     const res = await _BankAdminService.getSponserListByEmailAndBankAdminId(
  //       loginEmail,
  //       bankAdminId
  //     );

  //     if (res?.data?.IsSuccess && res.data.Obj?.length > 0) {
  //       setSponsors(res.data.Obj);
  //       // default select first sponsor
  //       console.log(res, "sponsor list 114555");
  //       const firstSponsorId = res.data.Obj[0].SponserId;

  //       console.log("TYPE:", loanProgrameType, typeof loanProgrameType);
  //       setSelectedSponsor(firstSponsorId);        
  //       fetchFirmAdminData(firstSponsorId);
  //     } else {
  //       message.warning("No sponsors found!");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching sponsor list:", error);
  //     message.error("Failed to load sponsors.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Select Firm
  const getFirmList = async () => {
    try {
      const res = await _BankAdminService.getFirmDropdownListByEmailAndBankAdminId(loginEmail, BankAdminID);
      if (res?.data?.IsSuccess && res.data.Obj) {
        setFirmList(res.data.Obj);
      }
    } catch (error) {
      console.error("Error fetching firm list:", error);
    }
  };

  // Select Credit Facility -- Loan Programe Types scoped to this Firm Admin's own assignments
  const getLoanProgramTypeList = async (firmId) => {
    try {
      const res = await _BankAdminService.getLoanProgrameTypeListByFirmId(firmId, { email: loginEmail, bankAdminId: BankAdminID });
      return res?.data?.IsSuccess && res.data.Obj ? res.data.Obj : [];
    } catch (error) {
      console.error("Error fetching loan programe type list:", error);
      return [];
    }
  };

  // 📌 Fetch data by sponsorId
  // const fetchFirmAdminData = async (sponsorId) => {

  //   try {
  //     setLoading(true);
  //     const res = await _BankAdminService.getFirmAdminAdvanceRepaymentDataBySponserId(sponsorId);

  //     if (res?.data?.IsSuccess && res.data.Obj) {

  //         setTotalAvailability(res.data.Obj.TotalAvailability)
  //       setTotalBorrowingBase(res.data.Obj.TotalBorrowingBase)
  //        setTotalOutstanding(res.data.Obj.TotalOutstanding)
  //       if (loanProgrameType === 2) {
  //        console.log(loanProgrameType, "type 22222"); 
  //         setDrawsData(res.data.Obj.firmAdvanceSubscriptionModel || []);
  //         setRepaymentsData(res.data.Obj.firmAdvanceRePaymentSubscriptionModel || []);
  //       } else {
  //         console.log(loanProgrameType, "tyoe normal"); 
  //         setDrawsData(res.data.Obj.firmAdvanceDrawModel || []);
  //         setRepaymentsData(res.data.Obj.firmAdvanceRePaymentModels || []);
  //       }

  //     } else {
  //       setDrawsData([]);
  //       setRepaymentsData([]);
  //       message.warning("No data available for this sponsor.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching advance/repayment data:", error);
  //     message.error("Failed to load advance/repayment data.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Fetch Advances/Repayments data by Firm + Credit Facility -- resolves the underlying
  // SponserId server-side (Sponser/GetFirmAdminAdvanceRepaymentDataByFirmAndLoanProgrameType),
  // which delegates to the existing GetFirmAdminAdvanceRepaymentDataBySponserId, so the
  // response/data shape is unchanged.
  const fetchFirmAdminData = async (firmId, loanType, sponserId) => {
    try {
      setLoading(true);

      const res = await _BankAdminService.getFirmAdminAdvanceRepaymentDataByFirmAndLoanProgrameType(firmId, loanType, sponserId);

      if (res?.data?.IsSuccess && res.data.Obj) {
        const obj = res.data.Obj;

        // Subscription Line of Credit (2) / Corporate Loan (4) can have more than one facility
        // (Sponser row) under the same firm+type, so there is no single "selectedSponsor" to key
        // off. A firm can technically have more than one facility of the same type, so the row-level
        // History action in the type 2/4 columns below still targets that specific row's SponserId --
        // this just gives the toolbar History button (like 1/3) a sensible default: the first facility.
        setTotalAvailability(obj.TotalAvailability);
        setTotalBorrowingBase(obj.TotalBorrowingBase);
        setTotalOutstanding(obj.TotalOutstanding);

        setLoanProgramSummary({
          Name: obj.Name,
          TotalProgrameSize: obj.TotalProgrameSize,
          AdvanceRate: obj.AdvanceRate,
          MaxLTV: obj.MaxLTV,
          RepaymentBasis: obj.RepaymentBasis,
          SweepPercentage: obj.SweepPercentage,
          IntrestExpense: obj.IntrestExpense,
        });

        setLastSubmittedByNameAdvance(obj.LastSubmittedByNameAdvance || null);
        setLastSubmittedDateAdvance(obj.LastSubmmitedDateAdvance || null);
        setLastSubmittedByNameRepayment(obj.LastSubmittedByNameRepayment || null);
        setLastSubmittedDateRepayment(obj.LastSubmmitedDateRepayment || null);

        if (Number(loanType) === 2) {
          const advanceRows = obj.firmAdvanceSubscriptionModel || [];
          setDrawsData(advanceRows);
          setRepaymentsData(obj.firmAdvanceRePaymentSubscriptionModel || []);
          setSelectedSponsor(advanceRows[0]?.SponserId ?? null);
        } else if (Number(loanType) === 4) {
          const advanceRows = obj.firmAdvanceCorporateLoanModel || [];
          setDrawsData(advanceRows);
          setRepaymentsData(obj.firmAdvanceRePaymentCorporateLoanModel || []);
          setSelectedSponsor(advanceRows[0]?.SponserId ?? null);
        } else {
          setDrawsData(obj.firmAdvanceDrawModel || []);
          setRepaymentsData(obj.firmAdvanceRePaymentModels || []);
          setSelectedSponsor(obj.Id ?? null);
        }
      } else {
        setDrawsData([]);
        setRepaymentsData([]);
        setLastSubmittedByNameAdvance(null);
        setLastSubmittedDateAdvance(null);
        setLastSubmittedByNameRepayment(null);
        setLastSubmittedDateRepayment(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // // 📌 Dropdown change handler
  // const handleSponsorChange = (sponsorId) => {
  //    setSelectedSponsor(sponsorId);
  // const selected = sponsors.find(
  //   (item) => item.SponserId === sponsorId
  // );
  // setLoanProgrameType(selected.LoanProgrameTypeId);
  // setSelectedSponsorDetails(selected);

  // fetchFirmAdminData(sponsorId);
  // };

  const handleFirmChange = (value) => {
    setSelectedFirm(value);
    setSelectedLoanProgramType(null);
    setLoanProgramTypeList([]);
    setDrawsData([]);
    setRepaymentsData([]);
    setSelectedSponsor(null);
  };

  const handleLoanProgramTypeChange = (value) => {
    // `value` is the selected dropdown entry's SponserId (unique per row); look up its
    // LoanProgrameTypeId from the list to keep type-branching working.
    const matchedFacility = loanProgramTypeList.find((type) => type.SponserId === value);
    setSelectedLoanProgramType(value);
    setLoanProgrameType(matchedFacility?.LoanProgrameTypeId ?? null);
    fetchFirmAdminData(selectedFirm, matchedFacility?.LoanProgrameTypeId, value);
  };

  // 📌 Function to download Draws PDF
  // const handleDownloadDrawsPDF = () => {
  //   const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const leftMargin = 3;
  //   const rightMargin = 3;
  //   doc.text("Advances Report", 20, 30);
  //   doc.setLineWidth(0.3);
  //   doc.line(leftMargin, 40, pageWidth - rightMargin, 40);

  //   autoTable(doc, {
  //     startY: 60,
  //     margin: { left: 3, right: 3 },
  //     headStyles: {
  //       fillColor: [25, 58, 106],
  //       textColor: [255, 255, 255],
  //       fontStyle: 'normal',
  //       cellPadding: { top: 10, bottom: 10, left: 4, right: 4 },
  //       lineWidth: 0.3,
  //       lineColor: [0, 0, 0],
  //     },
  //     bodyStyles: {
  //       cellPadding: 6,
  //       lineWidth: 0.3,
  //       lineColor: [0, 0, 0],
  //     },
  //     head: [
  //       [
  //         "Client Name",
  //         "Account Number",
  //         "Loan Amount ",
  //         "Outstanding ",
  //         "Availability",
  //         "Fair Market Value ",
  //         "Current LTV",
  //         "Gross Capital Call ",
  //         "Advance Rate ",
  //         "Maximum Available Draw",
  //         "Post-Funding Availability",
  //         "Post-Funding LTV",
  //         "LTV Result",
  //       ],
  //     ],
  //     body: drawsData.map((item) => [
  //       item.BorrowerName,
  //       item.AccountNumber,
  //       item.LoanAmount || "-",
  //       item.OutstandingBalanace || "-",
  //       item.Availability || "-",
  //       item.FairMarketValue || "-",
  //       item.AdvanceAmount || "-",
  //       item.CurrentLTV || "-",
  //       item.GrossDraw || "-",
  //       item.AdvanceRate || "-",
  //       item.MaximumAvailableDraw || "-",
  //       item.PostFundingAvailability || "-",
  //       item.PostFundingLTV || "-",
  //       item.LTVResult || "-",
  //     ]),
  //   });
  //   doc.save("Advances.pdf");
  // };

  const handleDownloadDrawsPDF = () => {
    let head = [];
    let body = [];

    // ✅ CONDITION BASED TABLE
    if (loanProgrameType === 2) {
      // 🔵 SUBSCRIPTION LINE OF CREDIT -- one row per Sponser facility

      head = [[
        "Borrower Fund",
        "Institution",
        "Total Commitment",
        "Unfunded Commitment",
        "Borrowing Base",
        "Outstanding",
        "Availability",
        "Advance Rate",
        "Requested Draw",
        "Post-Draw Availability",
        "Validation Result",
      ]];

      body = drawsData.map((item) => [
        item.BorrowerFund || "-",
        item.Institution || "-",
        item.TotalCommitment || "-",
        item.UnfundedCommitment || "-",
        item.BorrowingBase || "-",
        item.OutstandingBalanace || "-",
        item.Availability || "-",
        item.AdvanceRate || "-",
        item.RequestedDraw || "-",
        item.PostDrawAvailability || "-",
        item.ValidationResult || "-",
      ]);

    } else if (loanProgrameType === 4) {
      // 🟣 CORPORATE LOAN -- one row per Sponser facility (one portfolio company each)

      head = [[
        "Portfolio Company",
        "Institution",
        "Loan Structure",
        "Original Facility Size",
        "Current Outstanding Balance",
        "Availability",
        "Maturity Date",
        "Requested Draw",
        "Post-Draw Availability",
        "Validation Result",
      ]];

      body = drawsData.map((item) => [
        item.PortfolioCompany || "-",
        item.Institution || "-",
        item.LoanStructure || "-",
        item.OriginalFacilitySize || "-",
        item.OutstandingBalanace || "-",
        item.Availability || "-",
        formatDate(item.MaturityDate),
        item.RequestedDraw || "-",
        item.PostDrawAvailability || "-",
        item.ValidationResult || "-",
      ]);

    } else {
      // 🟢 NORMAL LOAN

      head = [[
        "Client Name",
        "Facility Reference",
        "Loan Amount",
        "Outstanding",
        "Availability",
        "Fair Market Value",
        "Current LTV",
        "Gross Capital Call",
        "Advance Rate",
        "Max LTV",
        "Advance Amount",
        "Post Funding Outstanding",
        "Maximum Available Draw",
        "Post-Funding Availability",
        "Post-Funding LTV",
        "LTV Result",
        "Fund(s)",
      ]];

      body = drawsData.map((item) => [
        item.BorrowerName,
        item.AccountNumber,
        item.LoanAmount || "-",
        item.OutstandingBalanace || "-",
        item.Availability || "-",
        item.FairMarketValue || "-",
        item.CurrentLTV || "-",
        item.GrossDraw || "-",
        item.AdvanceRate || "-",
        item.MaxLTV || "-",
        item.AdvanceAmount || "-",
        item.PostFundingOutstanding || "-",
        item.MaximumAvailableDraw || "-",
        item.PostFundingAvailability || "-",
        item.PostFundingLTV || "-",
        item.LTVResult || "-",
        item.FundPledges || "-",
      ]);
    }

    const pageWidth = Math.max(842, head[0].length * 110);
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: [pageWidth, 595] });

    const leftMargin = 3;
    const rightMargin = 3;

    doc.text("Advance & Repayment — Loan Program", 10, 30);
    doc.setLineWidth(0.3);
    doc.line(leftMargin, 40, pageWidth - rightMargin, 40);

    // The "Loan Program" summary sub-table (Program Size/Advance Rate/Max LTV/etc.) only applies to
    // 1/3 -- Subscription Line of Credit (2) / Corporate Loan (4) facilities don't have those fields
    // (loanProgramSummary is left unset for them), so it's skipped and the main table starts right
    // under the title line instead.
    let tableStartY = 50;
    if (loanProgrameType !== 2 && loanProgrameType !== 4) {
      const summaryColumnCount = 7;
      const summaryTableWidth = pageWidth - leftMargin - rightMargin;

      doc.text("Loan Program", 10, 68);

      autoTable(doc, {
        startY: 72,
        margin: { left: 3, right: 3 },
        tableWidth: summaryTableWidth,
        head: [[
          "Loan Program",
          "Program Size",
          "Advance Rate",
          "Max LTV",
          "Interest Rate",
          "Repayment Basis",
          "Sweep %"
        ]],
        body: [[
          loanProgramSummary.Name || "-",
          loanProgramSummary.TotalProgrameSize || "-",
          loanProgramSummary.AdvanceRate || "-",
          loanProgramSummary.MaxLTV || "-",
          loanProgramSummary.IntrestExpense || "-",
          loanProgramSummary.RepaymentBasis || "-",
          loanProgramSummary.SweepPercentage || "-",
        ]],

        styles: {
          cellWidth: summaryTableWidth / summaryColumnCount,
        },

        headStyles: {
          fillColor: [25, 58, 106],
          textColor: [255, 255, 255],
          fontStyle: "normal",
          fontSize: 18,
          cellPadding: { top: 10, bottom: 10, left: 4, right: 4 },
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },

        bodyStyles: {
          fontSize: 18,
          cellPadding: 6,
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
      });

      tableStartY = doc.lastAutoTable.finalY + 40;
    }

    doc.text("Advance", 10, tableStartY - 5);

    autoTable(doc, {
      startY: tableStartY,
      margin: { left: 3, right: 3 },
      head,
      body,

      headStyles: {
        fillColor: [25, 58, 106],
        textColor: [255, 255, 255],
        fontStyle: "normal",
        fontSize: 18,
        cellPadding: { top: 10, bottom: 10, left: 4, right: 4 },
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },

      bodyStyles: {
        fontSize: 18,
        cellPadding: 6,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
    });

    doc.save("Advances.pdf");
  };


  // 📌 Function to download Repayments PDF
  // const handleDownloadRepaymentsPDF = () => {
  //   const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   doc.text("Repayments Report", 20, 30);
  //   doc.setLineWidth(0.3);
  //   const leftMargin = 3;
  //   const rightMargin = 3;
  //   doc.setLineWidth(0.5);
  //   doc.line(leftMargin, 40, pageWidth - rightMargin, 40);

  //   autoTable(doc, {
  //     startY: 60,
  //     margin: { left: 3, right: 3 },
  //     headStyles: {
  //       fillColor: [25, 58, 106],
  //       textColor: [255, 255, 255],
  //       fontStyle: 'normal',
  //       cellPadding: { top: 10, bottom: 10, left: 4, right: 4 },
  //       lineWidth: 0.3,
  //       lineColor: [0, 0, 0],
  //     },
  //     bodyStyles: {
  //       cellPadding: 6,
  //       lineWidth: 0.3,
  //       lineColor: [0, 0, 0],
  //     },
  //     head: [
  //       [
  //         "Client Name",
  //         "Account Number",
  //         "Loan Amount ",
  //         "Outstanding ",
  //         "Availability",
  //         "Fair Market Value",
  //         "Cost Basis",
  //         "Gains",
  //         "Tax Rate",
  //         "Repayment",
  //         "Net Repayment",
  //         "Post-Repayment Outstanding",
  //         "Post-Repayment LTV",
  //       ],
  //     ],
  //     body: repaymentsData.map((item) => [
  //       item.BorrowerName,
  //       item.AccountNumber,
  //       item.LoanAmount || "-",
  //       item.OutstandingBalanace || "-",
  //       item.Availability,
  //       item.FairMarketValue,
  //       item.CostBasis,
  //       item.Gains,
  //       item.TaxRate || "-",
  //       item.RePayment || "-",
  //       item.NetPayment || "-",
  //       item.PostRepaymentOutstanding || "-",
  //       item.PostRepaymentLTV || "-",
  //     ]),
  //   });

  //   doc.save("Repayments.pdf");
  // };

  const handleDownloadRepaymentsPDF = () => {
    let head = [];
    let body = [];

    // ✅ CONDITION BASED ON LOAN TYPE
    if (loanProgrameType === 2) {
      // 🔵 SUBSCRIPTION LINE OF CREDIT -- one row per Sponser facility

      head = [[
        "Borrower Fund",
        "Institution",
        "Total Commitment",
        "Unfunded Commitment",
        "Borrowing Base",
        "Outstanding",
        "Availability",
        "Advance Rate",
        "Repayment",
        "Post-Repayment Availability",
        "Validation Result",
      ]];

      body = repaymentsData.map((item) => [
        item.BorrowerFund || "-",
        item.Institution || "-",
        item.TotalCommitment || "-",
        item.UnfundedCommitment || "-",
        item.BorrowingBase || "-",
        item.OutstandingBalanace || "-",
        item.Availability || "-",
        item.AdvanceRate || "-",
        item.Repayment || "-",
        item.PostRepaymentAvailability || "-",
        item.ValidationResult || "-",
      ]);

    } else if (loanProgrameType === 4) {
      // 🟣 CORPORATE LOAN -- one row per Sponser facility (one portfolio company each)

      head = [[
        "Portfolio Company",
        "Institution",
        "Loan Structure",
        "Original Facility Size",
        "Current Outstanding Balance",
        "Availability",
        "Maturity Date",
        "Repayment Amount",
        "Post-Repayment Availability",
        "Validation Result",
      ]];

      body = repaymentsData.map((item) => [
        item.PortfolioCompany || "-",
        item.Institution || "-",
        item.LoanStructure || "-",
        item.OriginalFacilitySize || "-",
        item.OutstandingBalanace || "-",
        item.Availability || "-",
        formatDate(item.MaturityDate),
        item.RepaymentAmount || "-",
        item.PostRepaymentAvailability || "-",
        item.ValidationResult || "-",
      ]);

    } else {
      // 🟢 NORMAL LOAN

      head = [[
        "Client Name",
        "Facility Reference",
        "Loan Amount",
        "Outstanding",
        "Availability",
        "Gross RePayment",
        // "Fair Market Value",
        "Cost Basis",
        "Sweep%",
        "Tax Rate",
        "Gains",
        "Tax",
        "Repayment Basis Amount",
        "Repayment Amount",
        "Post-Repayment Outstanding",
        "Post-Repayment Availability",
        "Post-Repayment LTV",
        "Repayment",
        "Net Repayment",
        "Fund(s)",
      ]];

      body = repaymentsData.map((item) => [
        item.BorrowerName,
        item.AccountNumber,
        item.LoanAmount || "-",
        item.OutstandingBalanace || "-",
        item.Availability || "-",
        item.GrossRePayment || "-",
        
        // item.FairMarketValue || "-",
        item.CostBasis || "-",
        item.SweepPercentage || "-",
        item.TaxRate || "-",
        item.Gains || "-",
        item.Tax || "-",
        item.RepaymentBasisAmount || "-",
        item.RepaymentAmount || "-",
        item.PostRepaymentOutstanding || "-",
        item.PostRepaymentAvailability || "-",
        item.PostRepaymentLTV || "-",
        item.RePayment || "-",
        item.NetPayment || "-",
        item.FundPledges || "-",
      ]);
    }

    const pageWidth = Math.max(842, head[0].length * 110);
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: [pageWidth, 595] });

    const leftMargin = 3;
    const rightMargin = 3;

    doc.text("Advance & Repayment — Loan Program", 10, 30);
    doc.setLineWidth(0.3);
    doc.line(leftMargin, 40, pageWidth - rightMargin, 40);

    // See handleDownloadDrawsPDF for why this summary sub-table is skipped for 2/4.
    let tableStartY = 50;
    if (loanProgrameType !== 2 && loanProgrameType !== 4) {
      const summaryColumnCount = 7;
      const summaryTableWidth = pageWidth - leftMargin - rightMargin;

      doc.text("Loan Program", 10, 68);

      autoTable(doc, {
        startY: 72,
        margin: { left: 3, right: 3 },
        tableWidth: summaryTableWidth,
        head: [[
          "Loan Program",
          "Program Size",
          "Advance Rate",
          "Max LTV",
          "Interest Rate",
          "Repayment Basis",
          "Sweep %"
        ]],
        body: [[
          loanProgramSummary.Name || "-",
          loanProgramSummary.TotalProgrameSize || "-",
          loanProgramSummary.AdvanceRate || "-",
          loanProgramSummary.MaxLTV || "-",
          loanProgramSummary.IntrestExpense || "-",
          loanProgramSummary.RepaymentBasis || "-",
          loanProgramSummary.SweepPercentage || "-",
        ]],
        styles: {
          cellWidth: summaryTableWidth / summaryColumnCount,
        },
        headStyles: {
          fillColor: [25, 58, 106],
          textColor: [255, 255, 255],
          fontStyle: 'normal',
          fontSize: 18,
          cellPadding: { top: 10, bottom: 10, left: 4, right: 4 },
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
        bodyStyles: {
          fontSize: 18,
          cellPadding: 6,
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
      });

      tableStartY = doc.lastAutoTable.finalY + 40;
    }

    doc.text("Repayment", 10, tableStartY - 5);

    autoTable(doc, {
      startY: tableStartY,
      margin: { left: 3, right: 3 },
      head,
      body,
      headStyles: {
        fillColor: [25, 58, 106],
        textColor: [255, 255, 255],
        fontStyle: 'normal',
        fontSize: 18,
        cellPadding: { top: 10, bottom: 10, left: 4, right: 4 },
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      bodyStyles: {
        fontSize: 18,
        cellPadding: 6,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
    });
    doc.save("Repayments.pdf");
  };

  const isEditing = (record) => record.ApplicationId === editingKey;
  const isRepaymentEditing = (record) => record.ApplicationId === editingRepaymentKey;

  const edithandleClick = (record) => {
    collapseCalculationRow(); // starting to edit a (possibly different) row always closes any stale expanded panel
    setEditingKey(record.ApplicationId);
    setEditingRow({ ...record });
  };
  const editRepaymenthandleClick = (record) => {
    collapseCalculationRow();
    setEditingRepaymentKey(record.ApplicationId);
    setEditingRepaymentRow({ ...record });
  };

  const savehandleClick = async (key) => {
    try {
      setLoading(true);

      const newData = [...drawsData];
      const index = newData.findIndex(
        (item) => item.ApplicationId === key
      );

      if (index === -1) {
        message.error("Record not found");
        setLoading(false);
        return false;
      }

      const parseNumericValue = (val) => {
        if (val === null || val === undefined || val === "") return null;
        const cleanValue =
          typeof val === "string" ? val.replace(/[^0-9.-]+/g, "") : val;
        const num = Number(cleanValue);
        return isNaN(num) ? null : num;
      };

      const isFacilityType = loanProgrameType === 2 || loanProgrameType === 4;
      const availability = parseNumericValue(editingRow.Availability);
      const advanceAmount = parseNumericValue(isFacilityType ? editingRow.RequestedDraw : editingRow.AdvanceAmount);

      if (availability !== null && advanceAmount !== null && advanceAmount > availability) {
        message.error(
          `Requested Draw cannot be greater than Availability (${formatCurrency(availability)})`
        );
        setLoading(false);
        return false;
      }

      const payload = isFacilityType
        ? {
            SponserId: editingRow.SponserId,
            LoanProgrameTypeId: loanProgrameType,
            ScreenName: "updateadvancesrepayments",
            AdvancePaymentAmount: editingRow.RequestedDraw,
            // Subscription Line of Credit (2) only -- editable Advance tab field; Borrowing Base
            // recalculates server-side from it (Uncalled Capital x Advance Rate).
            ...(loanProgrameType === 2 ? { UncalledCapital: editingRow.UncalledCapital } : {}),
          }
        : {
            Id: editingRow.Id,
            ScreenName: "updateadvancesrepayments",
            FairMarketValue: editingRow.FairMarketValue,
            AdvancePaymentAmount: editingRow.AdvanceAmount,
            GrossCapitalCall: editingRow.GrossDraw,
          };

      const res = await _NewapplicationService.submitApplicantData(payload);

      if (res?.data?.IsSuccess) {
        newData[index] = { ...editingRow };
        setDrawsData(newData);
        setRepaymentsData(prev =>
          prev.map(item =>
            item.ApplicationId === editingRow.ApplicationId
              ? { ...item, FairMarketValue: editingRow.FairMarketValue }
              : item
          )
        );
        message.success(res.data.Message || "Record updated successfully");
        await fetchFirmAdminData(selectedFirm, loanProgrameType, selectedLoanProgramType);
        setEditingKey(null);
        setEditingRow({});
        return true;
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
        return false;
      }

    } catch (error) {
      console.error("Update Error:", error);
      message.error("Something went wrong while saving");
      return false;
    } finally {
      setLoading(false);
    }
  };
  const savehandleRepaymentsClick = async (key) => {
    try {
      setLoading(true);

      const newData = [...repaymentsData];
      const index = newData.findIndex(
        (item) => item.ApplicationId === key
      );

      if (index === -1) {
        message.error("Record not found");
        setLoading(false);
        return false;
      }

      const isFacilityType = loanProgrameType === 2 || loanProgrameType === 4;
      const payload = isFacilityType
        ? {
            SponserId: editingRepaymentRow.SponserId,
            LoanProgrameTypeId: loanProgrameType,
            ScreenName: "updaterepayments",
            RePaymentAmount: loanProgrameType === 2 ? editingRepaymentRow.Repayment : editingRepaymentRow.RepaymentAmount,
          }
        : {
            Id: editingRepaymentRow.Id,
            ScreenName: "updaterepayments",
            FairMarketValue: editingRepaymentRow.FairMarketValue,
            GrossCapitalCall: editingRepaymentRow.GrossDraw,
            CostBasis: editingRepaymentRow.CostBasis,
            RePaymentAmount: editingRepaymentRow.RepaymentAmount,
            Gains: editingRepaymentRow.Gains,
            GrossRePayment: editingRepaymentRow.GrossRePayment,
          };

      const res = await _NewapplicationService.submitApplicantData(payload);

      if (res?.data?.IsSuccess) {
        newData[index] = { ...editingRepaymentRow };
        setRepaymentsData(newData);
        setDrawsData(prev =>
          prev.map(item =>
            item.ApplicationId === editingRepaymentRow.ApplicationId
              ? { ...item, FairMarketValue: editingRepaymentRow.FairMarketValue }
              : item
          )
        );
        message.success(res.data.Message || "Record updated successfully");
        await fetchFirmAdminData(selectedFirm, loanProgrameType, selectedLoanProgramType);
        setEditingRepaymentKey(null);
        setEditingRepaymentRow({});
        return true;
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
        return false;
      }

    } catch (error) {
      console.error("Update Error:", error);
      message.error("Something went wrong while saving");
      return false;
    } finally {
      setLoading(false);
    }
  };
  const cancelhandleClick = () => {
    collapseCalculationRow();
    setEditingKey(null);
    setEditingRow({});
  };
  const cancelRepaymenthandleClick = () => {
    collapseCalculationRow();
    setEditingRepaymentKey(null);
    setEditingRepaymentRow({});
  };

  const generateBatchNumber = (prefix) => `${prefix}-${Date.now()}`;

  const handleCertifyAndSubmitAdvancesBatch = async () => {
    if (selectedAdvanceRowKeys.length === 0) {
      message.warning("Please select at least one row to certify & submit batch.");
      return;
    }

    const selectedRows = drawsData.filter((row) =>
      selectedAdvanceRowKeys.includes(row.ApplicationId)
    );
    const batchNumber = generateBatchNumber("ADV");
    const isFacilityType = loanProgrameType === 2 || loanProgrameType === 4;
    const models = selectedRows.map((row) => isFacilityType
      ? {
          Id: 0,
          ApplicationId: null,
          SponserId: row.SponserId,
          ClientName: loanProgrameType === 2 ? row.Institution : row.PortfolioCompany,
          AccountNumber: null,
          BatchNumber: batchNumber,
          BatchType: "Advance",
          AdvanceAmount: row.RequestedDraw,
          RepaymentAmount: 0,
          FirmAdminId: firmAdminId,
          SubmittedByName: submittedByName,
          SubmittedDate: submittedDate,
          LoanProgrameTypeId: loanProgrameType,
          BorrowerFund: row.BorrowerFund,
          Institution: row.Institution,
          BorrowingBase: row.BorrowingBase,
          RequestedDraw: row.RequestedDraw,
          AdvanceRate: row.AdvanceRate,
          PortfolioCompany: row.PortfolioCompany,
          LoanStructure: row.LoanStructure,
          OriginalFacilitySize: row.OriginalFacilitySize,
          TotalCommitment: row.TotalCommitment,
          MaturityDate: row.MaturityDate,
          ValidationResult: row.ValidationResult,
        }
      : {
          Id: 0,
          ApplicationId: row.Id,
          SponserId: selectedSponsor,
          ClientName: row.BorrowerName,
          AccountNumber: row.AccountNumber,
          BatchNumber: batchNumber,
          BatchType: "Advance",
          AdvanceAmount: row.AdvanceAmount,
          RepaymentAmount: 0,
          FirmAdminId: firmAdminId,
          SubmittedByName: submittedByName,
          SubmittedDate: submittedDate,
        });

    try {
      setBatchSubmitting(true);
      const res = await _NewapplicationService.addApplicantAdvanceRepaymentBatchData(models);

      if (res?.data?.IsSuccess) {
        message.success(res.data.Message || "Batch submitted successfully");
        setSelectedAdvanceRowKeys([]);
        closeCertifyModal();
        await fetchFirmAdminData(selectedFirm, loanProgrameType, selectedLoanProgramType);
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Certify & Submit Batch (Advances) error:", error);
      message.error(COMMON_ERROR_MSG);
    } finally {
      setBatchSubmitting(false);
    }
  };

  const handleCertifyAndSubmitRepaymentsBatch = async () => {
    if (selectedRepaymentRowKeys.length === 0) {
      message.warning("Please select at least one row to submit.");
      return;
    }

    const selectedRows = repaymentsData.filter((row) =>
      selectedRepaymentRowKeys.includes(row.ApplicationId)
    );
    const batchNumber = generateBatchNumber("REP");
    const isFacilityType = loanProgrameType === 2 || loanProgrameType === 4;
    const models = selectedRows.map((row) => {
      if (!isFacilityType) {
        return {
          Id: 0,
          ApplicationId: row.Id,
          SponserId: selectedSponsor,
          ClientName: row.BorrowerName,
          AccountNumber: row.AccountNumber,
          BatchNumber: batchNumber,
          BatchType: "Repayment",
          AdvanceAmount: 0,
          RepaymentAmount: row.RepaymentAmount,
          FirmAdminId: firmAdminId,
          SubmittedByName: submittedByName,
          SubmittedDate: submittedDate,
        };
      }
      const repaymentValue = loanProgrameType === 2 ? row.Repayment : row.RepaymentAmount;
      return {
        Id: 0,
        ApplicationId: null,
        SponserId: row.SponserId,
        ClientName: loanProgrameType === 2 ? row.Institution : row.PortfolioCompany,
        AccountNumber: null,
        BatchNumber: batchNumber,
        BatchType: "Repayment",
        AdvanceAmount: 0,
        RepaymentAmount: repaymentValue,
        FirmAdminId: firmAdminId,
        SubmittedByName: submittedByName,
        SubmittedDate: submittedDate,
        LoanProgrameTypeId: loanProgrameType,
        BorrowerFund: row.BorrowerFund,
        Institution: row.Institution,
        BorrowingBase: row.BorrowingBase,
        RequestedDraw: repaymentValue,
        AdvanceRate: row.AdvanceRate,
        PortfolioCompany: row.PortfolioCompany,
        LoanStructure: row.LoanStructure,
        OriginalFacilitySize: row.OriginalFacilitySize,
        TotalCommitment: row.TotalCommitment,
        MaturityDate: row.MaturityDate,
        ValidationResult: row.ValidationResult,
      };
    });

    try {
      setBatchSubmitting(true);
      const res = await _NewapplicationService.addApplicantAdvanceRepaymentBatchData(models);

      if (res?.data?.IsSuccess) {
        message.success(res.data.Message || "Batch submitted successfully");
        setSelectedRepaymentRowKeys([]);
        closeCertifyModal();
        await fetchFirmAdminData(selectedFirm, loanProgrameType, selectedLoanProgramType);
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Certify & Submit Batch (Repayments) error:", error);
      message.error(COMMON_ERROR_MSG);
    } finally {
      setBatchSubmitting(false);
    }
  };

  const openCertifyModal = (batchType) => {
    const hasSelection = batchType === "Advance"
      ? selectedAdvanceRowKeys.length > 0
      : selectedRepaymentRowKeys.length > 0;

    if (!hasSelection) {
      message.warning(
        batchType === "Advance"
          ? "Please select at least one row to certify & submit batch."
          : "Please select at least one row to submit."
      );
      return;
    }

    setCertifyBatchType(batchType);
    setSubmittedByName("");
    const now = new Date();
    setSubmittedDate(now.toISOString());
    certifyForm.setFieldsValue({
      submittedByName: "",
      submittedDateDisplay: now.toLocaleString(),
    });
    setCertifyModalVisible(true);
  };

  const closeCertifyModal = () => {
    setCertifyModalVisible(false);
    setCertifyBatchType(null);
    setSubmittedByName("");
    setSubmittedDate(null);
    certifyForm.resetFields();
  };

  const handleCertifyModalSubmit = async () => {
    try {
      await certifyForm.validateFields();
    } catch {
      return;
    }

    if (certifyBatchType === "Advance") {
      handleCertifyAndSubmitAdvancesBatch();
    } else if (certifyBatchType === "Repayment") {
      handleCertifyAndSubmitRepaymentsBatch();
    }
  };

  const handlePreviewClick = async () => {
    try {
      setPreviewTab("advance");
      setExpandedRowKey(editingRow.ApplicationId); // expand immediately; panel shows its own loading state
      setPreviewLoading(true);

      const isFacilityType = loanProgrameType === 2 || loanProgrameType === 4;
      const payload = isFacilityType
        ? {
            // The preview controller requires Id > 0 regardless of loan type; for facility rows
            // Id equals SponserId (see SponserService.GetFirmAdminAdvanceRepaymentFacilityData).
            Id: editingRow.Id,
            SponserId: editingRow.SponserId,
            LoanProgrameTypeId: loanProgrameType,
            ScreenName: "updateadvancesrepayments",
            AdvancePaymentAmount: editingRow.RequestedDraw,
            // Subscription Line of Credit (2) only -- so the live preview recalculates Borrowing
            // Base from the value currently being edited, before it's saved.
            ...(loanProgrameType === 2 ? { UncalledCapital: editingRow.UncalledCapital } : {}),
          }
        : {
            Id: editingRow.Id,
            ScreenName: "updateadvancesrepayments",
            FairMarketValue: editingRow.FairMarketValue,
            AdvancePaymentAmount: editingRow.AdvanceAmount,
            GrossCapitalCall: editingRow.GrossDraw,
          };

      const res = await _BankAdminService.getAdvanceRepaymentCalculationPreview(payload);

      if (res?.data?.IsSuccess) {
        setPreviewData(res.data.Obj);
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Preview Error:", error);
      message.error("Something went wrong while calculating the preview");
    } finally {
      setPreviewLoading(false);
    }
  };

  const handlePreviewRepaymentClick = async () => {
    try {
      setPreviewTab("repayment");
      setExpandedRowKey(editingRepaymentRow.ApplicationId); // expand immediately; panel shows its own loading state
      setPreviewLoading(true);

      const isFacilityType = loanProgrameType === 2 || loanProgrameType === 4;
      const payload = isFacilityType
        ? {
            // The preview controller requires Id > 0 regardless of loan type; for facility rows
            // Id equals SponserId (see SponserService.GetFirmAdminAdvanceRepaymentFacilityData).
            Id: editingRepaymentRow.Id,
            SponserId: editingRepaymentRow.SponserId,
            LoanProgrameTypeId: loanProgrameType,
            ScreenName: "updaterepayments",
            RePaymentAmount: loanProgrameType === 2 ? editingRepaymentRow.Repayment : editingRepaymentRow.RepaymentAmount,
          }
        : {
            Id: editingRepaymentRow.Id,
            ScreenName: "updaterepayments",
            FairMarketValue: editingRepaymentRow.FairMarketValue,
            GrossCapitalCall: editingRepaymentRow.GrossDraw,
            CostBasis: editingRepaymentRow.CostBasis,
            RePaymentAmount: editingRepaymentRow.RepaymentAmount,
            Gains: editingRepaymentRow.Gains,
            GrossRePayment: editingRepaymentRow.GrossRePayment,
          };

      const res = await _BankAdminService.getAdvanceRepaymentCalculationPreview(payload);

      if (res?.data?.IsSuccess) {
        setPreviewData(res.data.Obj);
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Preview Error:", error);
      message.error("Something went wrong while calculating the preview");
    } finally {
      setPreviewLoading(false);
    }
  };

  const collapseCalculationRow = () => {
    setExpandedRowKey(null);
    setPreviewData(null);
    setPreviewTab(null);
  };

  // Note: "applicationId" sent to these endpoints is record.Id (Applicant.Id, the row's numeric PK) —
  // NOT record.ApplicationId (the display string like "App-10006"). ApplicantAdvance/ApplicantRepayment
  // store their ApplicationId column as an int matching Applicant.Id, per how history rows are inserted.
  const handleAdvanceHistoryClick = async (record) => {
    try {
      setHistoryLoading(true);
      setHistoryTab("advance");
      setHistoryModalVisible(true);

      const res = await _BankAdminService.getApplicantAdvanceHistoryByApplicationId(record.Id);

      if (res?.data?.IsSuccess) {
        setHistoryData(res.data.Obj || []);
      } else {
        setHistoryData([]);
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("History Error:", error);
      setHistoryData([]);
      message.error("Something went wrong while loading history");
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleRepaymentHistoryClick = async (record) => {
    try {
      setHistoryLoading(true);
      setHistoryTab("repayment");
      setHistoryModalVisible(true);

      const res = await _BankAdminService.getApplicantRepaymentHistoryByApplicationId(record.Id);

      if (res?.data?.IsSuccess) {
        setHistoryData(res.data.Obj || []);
      } else {
        setHistoryData([]);
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("History Error:", error);
      setHistoryData([]);
      message.error("Something went wrong while loading history");
    } finally {
      setHistoryLoading(false);
    }
  };

  const closeHistoryModal = () => {
    setHistoryModalVisible(false);
    setHistoryData([]);
    setHistoryTab(null);
  };

  // sponserIdOverride is used by the row-level History action on the Subscription Line of Credit (2) /
  // Corporate Loan (4) tables, where each row is its own Sponser facility and "selectedSponsor" (a
  // single firm-level facility, as used by the 1/3 toolbar History button) doesn't apply.
  const handleViewBatchHistory = async (batchType, sponserIdOverride) => {
    try {
      setBatchHistoryLoading(true);
      setBatchHistoryType(batchType);
      setBatchHistoryPage(1);
      setBatchHistoryModalVisible(true);

      const res = await _NewapplicationService.getApplicantAdvanceRepaymentBatchHistory(
        sponserIdOverride ?? selectedSponsor,
        batchType
      );

      if (res?.data?.IsSuccess) {
        setBatchHistoryData(res.data.Obj || []);
      } else {
        setBatchHistoryData([]);
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Batch History Error:", error);
      setBatchHistoryData([]);
      message.error("Something went wrong while loading batch history");
    } finally {
      setBatchHistoryLoading(false);
    }
  };

  const closeBatchHistoryModal = () => {
    setBatchHistoryModalVisible(false);
    setBatchHistoryData([]);
    setBatchHistoryType(null);
    setBatchHistoryPage(1);
  };

  // Reuses the existing savehandleClick/savehandleRepaymentsClick unchanged — same API,
  // validation, and messaging. Only closes the popup when the save actually succeeded;
  // on failure the popup stays open so the user can see the error and adjust values.
  const handleSaveFromPreview = async () => {
    setPreviewSaving(true);
    const success =
      previewTab === "advance"
        ? await savehandleClick(editingRow.ApplicationId)
        : await savehandleRepaymentsClick(editingRepaymentRow.ApplicationId);
    setPreviewSaving(false);
    if (success) {
      collapseCalculationRow();
    }
  };

  // Inserts one synthetic, read-only "Calculation Summary" row immediately after the row currently
  // being edited/calculated. It reuses the exact same columns array as the real table, so calculated
  // values land under their real column headers instead of a separate detail panel or popup. Only
  // active for whichever tab type last triggered Calculate (previewTab), so the same ApplicationId
  // appearing in both Advance and Repayment tabs never gets a stray row on the wrong table.
  const buildDataSourceWithCalcRow = (pageData, tabType) => {
    if (previewTab !== tabType || !expandedRowKey) return pageData;
    const idx = pageData.findIndex((r) => r.ApplicationId === expandedRowKey);
    if (idx === -1) return pageData;

    const calcRow = {
      ...pageData[idx],
      ApplicationId: `${expandedRowKey}__calc-summary`, // distinct rowKey, avoids colliding with the real row
      __isCalcSummaryRow: true,
    };
    const result = [...pageData];
    result.splice(idx + 1, 0, calcRow);
    return result;
  };

  // Decorates an existing columns array (unchanged for every normal row) so the synthetic calc-summary
  // row above renders each column's calculated value from previewData (previewData's field names match
  // the main table's dataIndex values 1:1, since both come from the same backend response shape), and
  // renders Save/Cancel in the Action column instead of Edit/Calculator/Cancel.
  const decorateColumnsForCalcRow = (columns) =>
    columns.map((col) => {
      const originalRender = col.render;

      if (col.title === "Action") {
        return {
          ...col,
          render: (value, record, index) => {
            if (!record.__isCalcSummaryRow) {
              return originalRender ? originalRender(value, record, index) : value;
            }
            const cancelFn = previewTab === "repayment" ? cancelRepaymenthandleClick : cancelhandleClick;
            return (
              <div className="actionColumnDiv">
                <Tooltip title="Save">
                  <Button
                    type="link"
                    loading={previewSaving}
                    disabled={!previewData || previewLoading}
                    onClick={handleSaveFromPreview}
                    icon={<SaveTwoTone />}
                  />
                </Tooltip>
                <Tooltip title="Cancel">
                  <Button type="link" onClick={cancelFn} icon={<CloseOutlined />} />
                </Tooltip>
              </div>
            );
          },
        };
      }

      return {
        ...col,
        render: (value, record, index) => {
          if (!record.__isCalcSummaryRow) {
            return originalRender ? originalRender(value, record, index) : value;
          }
          if (previewLoading) {
            return <div className="calc-cell-loading-bar" />;
          }
          const dataKey = col.dataIndex;
          const calcValue = dataKey ? previewData?.[dataKey] : undefined;
          return calcValue ?? "-";
        },
      };
    });

  const handleTabChange = (key) => {
    cancelhandleClick();
    cancelRepaymenthandleClick();
    setEditingRow(null);
    setEditingRepaymentRow(null);
    setActiveTabKey(key);
  };

  const handleFairMarketChange = (value, record) => {
    const newData = [...drawsData];
    const index = newData.findIndex(
      (item) => item.BorrowerName === record.BorrowerName
    );

    if (index > -1) {
      newData[index].FairMarketValue = value;
      setDrawsData(newData);
    }
  };
  const formatCurrency = (value) => {
    console.log(value, "value 11");

    if (value === null || value === undefined || value === "")
      return "-";

    const cleanValue =
      typeof value === "string"
        ? value.replace(/[^0-9.-]+/g, "")
        : value;

    const num = Number(cleanValue);

    return !isNaN(num)
      ? `$${num.toLocaleString("en-US", { minimumFractionDigits: 2 })}`
      : "-";
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("en-US");
  };

  // Subscription Line of Credit (2) / Corporate Loan (4) facility rows -- Sponser.AdvanceRate is stored
  // as a plain number string (e.g. "92"), unlike the 1/3 tables' AdvanceRate which the backend already
  // suffixes with "%".
  const formatPercent = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const str = String(value);
    return str.includes("%") ? str : `${str}%`;
  };

  // Transaction History popup columns — same field names as ApplicantAdvanceModel/ApplicantRepaymentModel
  // (reviewed, not assumed). "Transaction Date" and "Created Date" are the same underlying CreatedDate
  // field on these models (there is no separate transaction-date column), so they're shown as one column.
  const getHistoryColumns = (tab) => {
    const common = [
      {
        title: "Transaction Date",
        dataIndex: "CreatedDate",
        render: (value) => formatDate(value),
        sorter: (a, b) => new Date(a.CreatedDate || 0) - new Date(b.CreatedDate || 0),
        // No defaultSortOrder: the backend already returns IsLatest first, then CreatedDate/Id
        // descending — applying a default client-side sort here would override that on initial load.
        // Sorting is still available on user click.
      },
      { title: "Application Number", dataIndex: "ApplicationIdStr", render: (value) => value || "-" },
      { title: "Applicant Name", dataIndex: "ClientName", render: (value) => value || "-" },
      { title: "Facility Reference", dataIndex: "AccountNumber", render: (value) => value || "-" },
      { title: "Fair Market Value", dataIndex: "FairMarketValue", render: (value) => formatCurrency(value) },
    ];

    const advanceOnly = [
      { title: "Gross Capital Call", dataIndex: "GrossCapitalCall", render: (value) => formatCurrency(value) },
      { title: "Advance Amount", dataIndex: "AdvanceAmount", render: (value) => formatCurrency(value), sorter: (a, b) => (parseFloat((a.AdvanceAmount || "0").replace(/[^0-9.-]+/g, "")) || 0) - (parseFloat((b.AdvanceAmount || "0").replace(/[^0-9.-]+/g, "")) || 0) },
    ];

    const repaymentOnly = [
      { title: "Cost Basis", dataIndex: "CostBasis", render: (value) => formatCurrency(value) },
      { title: "Gains", dataIndex: "Gains", render: (value) => formatCurrency(value) },
      { title: "Repayment Amount", dataIndex: "RepaymentAmount", render: (value) => formatCurrency(value), sorter: (a, b) => (parseFloat((a.RepaymentAmount || "0").replace(/[^0-9.-]+/g, "")) || 0) - (parseFloat((b.RepaymentAmount || "0").replace(/[^0-9.-]+/g, "")) || 0) },
    ];

    const tail = [
      { title: "Current Outstanding", dataIndex: "OutstandingAsOf", render: (value) => formatCurrency(value) },
      { title: "Availability", dataIndex: "Availability", render: (value) => formatCurrency(value) },
      { title: "Created By", dataIndex: "CreatedBy", render: (value) => value ?? "-" },
    ];

    return tab === "repayment"
      ? [...common, ...repaymentOnly, ...tail]
      : [...common, ...advanceOnly, ...tail];
  };

  // Certify & Submit Batch history popup columns — same 7 fields the API returns per
  // ApplicantAdvanceRepaymentBatchModel, shown as-is (per request, no client-side reformatting
  // except SubmittedDate, which follows the existing UI date format via formatDate).
  const submittedDateColumn = {
    title: "Submitted Date",
    dataIndex: "SubmittedDate",
    render: (value) => formatDate(value),
    sorter: (a, b) => new Date(a.SubmittedDate || 0) - new Date(b.SubmittedDate || 0),
  };

  // Certify & Submit Batch status (CertifyBatch.md Section 5.4) -- shows whether a batch is still
  // waiting for a Senior Private Banker/Underwriter Banker to certify it, or already has been,
  // plus who certified it and when once it is.
  const statusColumn = {
    title: "Status",
    dataIndex: "Status",
    render: (value, record) => {
      if (value === "Certified") {
        const certifiedDate = record.CertifiedDate ? formatDate(record.CertifiedDate) : "-";
        return `Certified by ${record.CertifiedByName || "-"} on ${certifiedDate}`;
      }
      return value || "Submitted";
    },
  };

  const getBatchHistoryColumns = () => {
    if (loanProgrameType === 2) {
      // Subscription Line of Credit -- RequestedDraw holds the Repayment tab's amount too (same
      // batch-row snapshot column reused for both, per AddApplicantAdvanceRepaymentBatchData).
      return [
        { title: "Batch Number", dataIndex: "BatchNumber", render: (value) => value ?? "-" },
        { title: "Facility", dataIndex: "Institution", render: (value) => value ?? "-" },
        { title: "Borrower Fund", dataIndex: "BorrowerFund", render: (value) => value ?? "-" },
        { title: "Total Commitment", dataIndex: "TotalCommitment", render: (value) => formatCurrency(value) },
        batchHistoryType === "Repayment"
          ? { title: "Repayment Amount", dataIndex: "RequestedDraw", render: (value) => formatCurrency(value) }
          : { title: "Advance Amount", dataIndex: "AdvanceAmount", render: (value) => formatCurrency(value) },
        submittedDateColumn,
        statusColumn,
      ];
    }

    if (loanProgrameType === 4) {
      return [
        { title: "Batch Number", dataIndex: "BatchNumber", render: (value) => value ?? "-" },
        { title: "Portfolio Company", dataIndex: "PortfolioCompany", render: (value) => value ?? "-" },
        { title: "Facility", dataIndex: "Institution", render: (value) => value ?? "-" },
        { title: "Loan Structure", dataIndex: "LoanStructure", render: (value) => value ?? "-" },
        { title: "Original Facility Size", dataIndex: "OriginalFacilitySize", render: (value) => formatCurrency(value) },
        batchHistoryType === "Repayment"
          ? { title: "Repayment Amount", dataIndex: "RequestedDraw", render: (value) => formatCurrency(value) }
          : { title: "Advance Amount", dataIndex: "AdvanceAmount", render: (value) => formatCurrency(value) },
        submittedDateColumn,
        statusColumn,
      ];
    }

    return [
      { title: "Batch Number", dataIndex: "BatchNumber", render: (value) => value ?? "-" },
      { title: "ApplicationId", dataIndex: "ApplicationIdStr", render: (value) => value ?? "-" },
      { title: "Client Name", dataIndex: "ClientName", render: (value) => value ?? "-" },
      { title: "Facility Reference", dataIndex: "AccountNumber", render: (value) => value ?? "-" },
      { title: "Advance Amount", dataIndex: "AdvanceAmount", render: (value) => value ?? "-" },
      { title: "Repayment Amount", dataIndex: "RepaymentAmount", render: (value) => value ?? "-" },
      submittedDateColumn,
      statusColumn,
    ];
  };

  console.log(selectedSponsorDetails, "selectedSponsorDetails")
  return (
    <SidebarLayout>
      <div className="advances-repayments-container">
        <Title level={3} className="page-title">
          Advances & Repayments
        </Title>
        <Title level={5} className="page-sub-title">
          Track borrower draws and repayments
        </Title>

        <div className="card-section choose-loan-program-section inputDisabledBlackColor">
          <div className="facility-selectors">
            <label className="choose-loan-program-label">Select Firm : </label>
            <Select
              placeholder="Select Firm"
              value={selectedFirm}
              onChange={handleFirmChange}
            >
              {firmList.map((firm) => (
                <Option key={firm.Id} value={firm.Id}>
                  {firm.FirmName}
                </Option>
              ))}
            </Select>

            <label className="choose-loan-program-label">Select Credit Facility : </label>
            <Select
              placeholder="Select Credit Facility"
              value={selectedLoanProgramType}
              onChange={handleLoanProgramTypeChange}
            >
              {loanProgramTypeList.map((type) => (
                <Option key={type.SponserId} value={type.SponserId}>
                  {type.Name}
                </Option>
              ))}
            </Select>
          </div>

          {(() => {
            const tabSubmittedByName = activeTabKey === "2" ? lastSubmittedByNameRepayment : lastSubmittedByNameAdvance;
            const tabSubmittedDate = activeTabKey === "2" ? lastSubmittedDateRepayment : lastSubmittedDateAdvance;
            return tabSubmittedByName && tabSubmittedDate ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 4, color: "#f4f4f5b2" }}>
                <span>
                  <strong style={{ color: "#f4f4f5" }}>Submitted By :</strong> {tabSubmittedByName}
                </span>
                <span>
                  <strong style={{ color: "#f4f4f5" }}>Date &amp; Time :</strong>{" "}
                  {moment.utc(tabSubmittedDate).local().format("MM/DD/YYYY hh:mm A")}
                </span>
              </div>
            ) : null;
          })()}
          {/* <FormItemSelect
              label=""
              name="sponsorSelect"
              placeholder="Select Sponsor"
              value={selectedSponsor}
              onChange={handleSponsorChange}
              options={sponsors.map((sponsor) => ({
                label: sponsor.SponserName,
                value: sponsor.SponserId,
              }))}
            /> */}
        </div>
        {/* Total Availability / Borrowing Base / Outstanding summary hidden per request
        <div className="card-section mb10">
          <Row gutter={16} className="loan-program-summary">
            <Col>
              <label className="choose-loan-program-label">Total Availability : </label>
              <label>{totalAvailability}</label>
            </Col>
            <Col>
              <label className="choose-loan-program-label">Total Borrowing Base : </label>
              <label>{totalBorrowingBase} </label>
            </Col>
            <Col>
              <label className="choose-loan-program-label">Total Outstanding : </label>
              <label>{totalOutstanding} </label>
            </Col>
          </Row>
        </div>
        */}


        {/* {loading ? (
        <Spin size="large" />
      ) : ( */}
        <Spin spinning={loading}>
          <Tabs onChange={(key) => handleTabChange(key)} defaultActiveKey="1" type="line" className="card-section tab-section">
            {/* ✅ Draws Tab */}
            <TabPane tab="Advances" key="1">
              {/* Subscription Line of Credit -- one row per Sponser facility */}
              {
                loanProgrameType === 2 &&
                <Table
                  columns={decorateColumnsForCalcRow([
                    { title: "Borrower Fund", dataIndex: "BorrowerFund", render: (value) => value || "-" },
                    { title: "Facility", dataIndex: "Institution", render: (value) => value || "-" },
                    { title: "Total Commitment", dataIndex: "TotalCommitment", render: (value) => formatCurrency(value) },
                    { title: "Unfunded Commitment", dataIndex: "UnfundedCommitment", render: (value) => formatCurrency(value) },
                    {
                      title: "Uncalled Capital",
                      dataIndex: "UncalledCapital",
                      render: (value, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRow.UncalledCapital}
                            onChange={(val) =>
                              setEditingRow({ ...editingRow, UncalledCapital: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Borrowing Base", dataIndex: "BorrowingBase", render: (value) => formatCurrency(value) },
                    {
                      title: (
                        <div style={{ lineHeight: 1.2 }}>
                          <div>Outstanding</div>
                          <div style={{ fontSize: "12px" }}>As of:</div>
                        </div>
                      ),
                      dataIndex: "OutstandingBalanace",
                      render: (value) => formatCurrency(value),
                    },
                    { title: "Availability", dataIndex: "Availability", render: (value) => formatCurrency(value) },
                    { title: "Advance Rate", dataIndex: "AdvanceRate", render: (value) => formatPercent(value) },
                    {
                      title: "Requested Draw",
                      dataIndex: "RequestedDraw",
                      render: (value, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRow.RequestedDraw}
                            onChange={(val) =>
                              setEditingRow({ ...editingRow, RequestedDraw: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Post-Draw Availability", dataIndex: "PostDrawAvailability", render: (value) => formatCurrency(value) },
                    { title: "Validation Result", dataIndex: "ValidationResult", render: (value) => value || "-" },
                    {
                      title: "Action",
                      dataIndex: "action",
                      key: "action",
                      align: "center",
                      fixed: "right",
                      width: 170,
                      render: (_, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <div className="actionColumnDiv">
                            <Tooltip title="Calculation Summary">
                              <Button
                                type="link"
                                loading={previewLoading}
                                onClick={handlePreviewClick}
                                icon={<img src="/calculator.png.png" alt="Calculate" style={{ width: 16, height: 16 }} />}
                              />
                            </Tooltip>

                            <Tooltip title="Cancel">
                              <Button
                                type="link"
                                onClick={cancelhandleClick}
                                icon={<CloseOutlined />}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="actionColumnDiv">
                            <Tooltip title="Edit">
                              <Button
                                type="link"
                                onClick={() => edithandleClick(record)}
                                icon={<EditTwoTone />}
                              />
                            </Tooltip>

                            <Tooltip title="History">
                              <Button
                                type="link"
                                onClick={() => handleViewBatchHistory("Advance", record.SponserId)}
                                icon={<EyeOutlined />}
                              />
                            </Tooltip>

                            <span
                              style={{
                                display: "inline-flex",
                                width: 45,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                checked={selectedAdvanceRowKeys.includes(record.ApplicationId)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setSelectedAdvanceRowKeys((prev) =>
                                    checked
                                      ? [...prev, record.ApplicationId]
                                      : prev.filter((id) => id !== record.ApplicationId)
                                  );
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    }
                  ])}
                  dataSource={buildDataSourceWithCalcRow(drawsData.slice((drawsPage - 1) * pageSize, drawsPage * pageSize), "advance")}
                  rowKey="ApplicationId"
                  pagination={false}
                  className="transparent-table advancesTableMain"
                  locale={{ emptyText: getTableEmptyText() }}
                  scroll={{ x: "max-content" }}
                  rowClassName={(record) => (record.__isCalcSummaryRow ? "calc-summary-row" : "")}
                />
              }

              {/* Corporate Loan -- one row per Sponser facility (one portfolio company each) */}
              {
                loanProgrameType === 4 &&
                <Table
                  columns={decorateColumnsForCalcRow([
                    { title: "Portfolio Company", dataIndex: "PortfolioCompany", render: (value) => value || "-" },
                    { title: "Facility", dataIndex: "Institution", render: (value) => value || "-" },
                    { title: "Loan Structure", dataIndex: "LoanStructure", render: (value) => value || "-" },
                    { title: "Original Facility Size", dataIndex: "OriginalFacilitySize", render: (value) => formatCurrency(value) },
                    {
                      title: (
                        <div style={{ lineHeight: 1.2 }}>
                          <div>Current Outstanding Balance</div>
                          <div style={{ fontSize: "12px" }}>As of:</div>
                        </div>
                      ),
                      dataIndex: "OutstandingBalanace",
                      render: (value) => formatCurrency(value),
                    },
                    { title: "Availability", dataIndex: "Availability", render: (value) => formatCurrency(value) },
                    { title: "Maturity Date", dataIndex: "MaturityDate", render: (value) => formatDate(value) },
                    {
                      title: "Requested Draw",
                      dataIndex: "RequestedDraw",
                      render: (value, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRow.RequestedDraw}
                            onChange={(val) =>
                              setEditingRow({ ...editingRow, RequestedDraw: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Post-Draw Availability", dataIndex: "PostDrawAvailability", render: (value) => formatCurrency(value) },
                    { title: "Validation Result", dataIndex: "ValidationResult", render: (value) => value || "-" },
                    {
                      title: "Action",
                      dataIndex: "action",
                      key: "action",
                      align: "center",
                      fixed: "right",
                      width: 170,
                      render: (_, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <div className="actionColumnDiv">
                            <Tooltip title="Calculation Summary">
                              <Button
                                type="link"
                                loading={previewLoading}
                                onClick={handlePreviewClick}
                                icon={<img src="/calculator.png.png" alt="Calculate" style={{ width: 16, height: 16 }} />}
                              />
                            </Tooltip>

                            <Tooltip title="Cancel">
                              <Button
                                type="link"
                                onClick={cancelhandleClick}
                                icon={<CloseOutlined />}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="actionColumnDiv">
                            <Tooltip title="Edit">
                              <Button
                                type="link"
                                onClick={() => edithandleClick(record)}
                                icon={<EditTwoTone />}
                              />
                            </Tooltip>

                            <Tooltip title="History">
                              <Button
                                type="link"
                                onClick={() => handleViewBatchHistory("Advance", record.SponserId)}
                                icon={<EyeOutlined />}
                              />
                            </Tooltip>

                            <span
                              style={{
                                display: "inline-flex",
                                width: 45,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                checked={selectedAdvanceRowKeys.includes(record.ApplicationId)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setSelectedAdvanceRowKeys((prev) =>
                                    checked
                                      ? [...prev, record.ApplicationId]
                                      : prev.filter((id) => id !== record.ApplicationId)
                                  );
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    }
                  ])}
                  dataSource={buildDataSourceWithCalcRow(drawsData.slice((drawsPage - 1) * pageSize, drawsPage * pageSize), "advance")}
                  rowKey="ApplicationId"
                  pagination={false}
                  className="transparent-table advancesTableMain"
                  locale={{ emptyText: getTableEmptyText() }}
                  scroll={{ x: "max-content" }}
                  rowClassName={(record) => (record.__isCalcSummaryRow ? "calc-summary-row" : "")}
                />
              }

              {/* for gp */}
              {
                loanProgrameType !== 2 && loanProgrameType !== 4 &&
                <Table
                  columns={decorateColumnsForCalcRow([
                    { title: "Client Name", dataIndex: "BorrowerName", },
                    { title: "Facility Reference", dataIndex: "AccountNumber", },
                    {
                      title: "Loan Amount ",
                      dataIndex: "LoanAmount",
                      render: (value) => value || "-"
                    },
                    {
                      title: (
                        <div style={{ lineHeight: 1.2 }}>
                          <div>Outstanding</div>
                          <div style={{ fontSize: "12px" }}>As of:</div>
                        </div>
                      ),
                      dataIndex: "OutstandingBalanace",
                      render: (value) => value || "-"
                    },
                    { title: "Availability", dataIndex: "Availability", },
                    {
                      title: "Fair Market Value ",
                      dataIndex: "FairMarketValue",
                      render: (value, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRow.FairMarketValue}
                            onChange={(val) =>
                              setEditingRow({ ...editingRow, FairMarketValue: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Current LTV", dataIndex: "CurrentLTV", },
                    {
                      title: "Gross Capital Call ",
                      dataIndex: "GrossDraw",
                      render: (value, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRow.GrossDraw}
                            onChange={(val) =>
                              setEditingRow({ ...editingRow, GrossDraw: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Advance Rate", dataIndex: "AdvanceRate", },
                    { title: "Max LTV", dataIndex: "MaxLTV", },
                    {
                      title: "Advance Amount",
                      // Read-only per requirement — no longer user-editable. Still fully calculated by
                      // the existing business logic (Preview/Save/CalculateAdvance are all unchanged);
                      // this cell simply no longer renders an input for it.
                      dataIndex: "AdvanceAmount",
                      render: (value) => formatCurrency(value),
                    },
                    {
                      title: (
                        <div>
                          Maximum Available <br />
                          Draw
                        </div>
                      ),
                      dataIndex: "MaximumAvailableDraw",
                    },
                    { title: "Post Funding Outstanding", dataIndex: "PostFundingOutstanding" },
                    {
                      title: (
                        <div>
                          Post-Funding <br />
                          Availability
                        </div>
                      ),
                      dataIndex: "PostFundingAvailability",
                    },
                    {
                      title: (
                        <div>
                          Post-Funding <br />
                          LTV
                        </div>
                      ),
                      dataIndex: "PostFundingLTV",
                    },
                    { title: "LTV Result", dataIndex: "LTVResult" },
                    { title: "Fund(s)", dataIndex: "FundPledges", render: (value) => value || "-" },
                    // { title: "Net Funded Amount ", dataIndex: "FundedAmount" },
                    {
                      title: "Action",
                      dataIndex: "action",
                      key: "action",
                      align: "center",
                      fixed: "right",
                      width: 140,
                      render: (_, record) => {
                        const editable = isEditing(record);

                        return editable ? (
                          <div className="actionColumnDiv">
                            <Tooltip title="Calculation Summary">
                              <Button
                                type="link"
                                loading={previewLoading}
                                onClick={handlePreviewClick}
                                icon={<img src="/calculator.png.png" alt="Calculate" style={{ width: 16, height: 16 }} />}
                              />
                            </Tooltip>

                            <Tooltip title="Cancel">
                              <Button
                                type="link"
                                onClick={cancelhandleClick}
                                icon={<CloseOutlined />}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="actionColumnDiv">
                            <Tooltip title="Edit">
                              <Button
                                type="link"
                                onClick={() => edithandleClick(record)}
                                icon={<EditTwoTone />}
                              />
                            </Tooltip>

                            {/* <Tooltip title="History">
                              <Button
                                type="link"
                                onClick={() => handleAdvanceHistoryClick(record)}
                                icon={<EyeOutlined />}
                              />
                            </Tooltip> */}

                            <span
                              style={{
                                display: "inline-flex",
                                width: 45,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                checked={selectedAdvanceRowKeys.includes(record.ApplicationId)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setSelectedAdvanceRowKeys((prev) =>
                                    checked
                                      ? [...prev, record.ApplicationId]
                                      : prev.filter((id) => id !== record.ApplicationId)
                                  );
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    }
                  ])}
                  dataSource={buildDataSourceWithCalcRow(drawsData.slice((drawsPage - 1) * pageSize, drawsPage * pageSize), "advance")}
                  rowKey="ApplicationId"
                  pagination={false}
                  className="transparent-table advancesTableMain"
                  locale={{ emptyText: getTableEmptyText() }}
                  scroll={{ x: "max-content" }}
                  rowClassName={(record) => (record.__isCalcSummaryRow ? "calc-summary-row" : "")}
                />
              }
              <div
                className="table-footer"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <Pagination
                  current={drawsPage}
                  pageSize={pageSize}
                  total={drawsData.length}
                  onChange={(page) => setDrawsPage(page)}
                  className="pagination"
                />
                <div className="toolbar-actions">
                  <ButtonComponent
                    className="view-btn"
                    type="default"
                    text="History"
                    onClick={() => handleViewBatchHistory("Advance")}
                  />
                  <ButtonComponent
                    className="view-btn"
                    type="default"
                    text="Download"
                    onClick={handleDownloadDrawsPDF}
                  />
                  <ButtonComponent
                    className="view-btn"
                    text="Send to Senior Banker"
                    onClick={() => openCertifyModal("Advance")}
                    loading={batchSubmitting}
                  />
                </div>
              </div>

            </TabPane>

            {/* ✅ Repayments Tab */}
            <TabPane tab="Repayments" key="2">
              {/* Subscription Line of Credit -- one row per Sponser facility */}
              {
                loanProgrameType === 2 &&
                <Table
                  columns={decorateColumnsForCalcRow([
                    { title: "Borrower Fund", dataIndex: "BorrowerFund", render: (value) => value || "-" },
                    { title: "Facility", dataIndex: "Institution", render: (value) => value || "-" },
                    { title: "Total Commitment", dataIndex: "TotalCommitment", render: (value) => formatCurrency(value) },
                    { title: "Unfunded Commitment", dataIndex: "UnfundedCommitment", render: (value) => formatCurrency(value) },
                    // Read-only on the Repayment tab -- editing happens on the Advance tab.
                    { title: "Uncalled Capital", dataIndex: "UncalledCapital", render: (value) => formatCurrency(value) },
                    { title: "Borrowing Base", dataIndex: "BorrowingBase", render: (value) => formatCurrency(value) },
                    {
                      title: (
                        <div style={{ lineHeight: 1.2 }}>
                          <div>Outstanding</div>
                          <div style={{ fontSize: "12px" }}>As of:</div>
                        </div>
                      ),
                      dataIndex: "OutstandingBalanace",
                      render: (value) => formatCurrency(value),
                    },
                    { title: "Availability", dataIndex: "Availability", render: (value) => formatCurrency(value) },
                    { title: "Advance Rate", dataIndex: "AdvanceRate", render: (value) => formatPercent(value) },
                    {
                      title: "Repayment",
                      dataIndex: "Repayment",
                      render: (value, record) => {
                        const editable = isRepaymentEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRepaymentRow.Repayment}
                            onChange={(val) =>
                              setEditingRepaymentRow({ ...editingRepaymentRow, Repayment: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Post-Repayment Availability", dataIndex: "PostRepaymentAvailability", render: (value) => formatCurrency(value) },
                    { title: "Validation Result", dataIndex: "ValidationResult", render: (value) => value || "-" },
                    {
                      title: "Action",
                      fixed: "right",
                      width: 170,
                      render: (_, record) => {
                        const editable = isRepaymentEditing(record);
                        return editable ? (
                          <div className="actionColumnDiv">
                            <Tooltip title="Calculation Summary">
                              <Button type="link" loading={previewLoading} onClick={handlePreviewRepaymentClick}
                                icon={<img src="/calculator.png.png" alt="Calculate" style={{ width: 16, height: 16 }} />}
                              />
                            </Tooltip>
                            <Tooltip title="Cancel">
                              <Button type="link" onClick={cancelRepaymenthandleClick}
                                icon={<CloseOutlined />}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="actionColumnDiv">
                            <Tooltip title="Edit">
                              <Button type="link" onClick={() => editRepaymenthandleClick(record)}
                                icon={<EditTwoTone />}
                              />
                            </Tooltip>
                            <Tooltip title="History">
                              <Button type="link" onClick={() => handleViewBatchHistory("Repayment", record.SponserId)}
                                icon={<EyeOutlined />}
                              />
                            </Tooltip>
                            <span
                              style={{
                                display: "inline-flex",
                                width: 45,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                checked={selectedRepaymentRowKeys.includes(record.ApplicationId)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setSelectedRepaymentRowKeys((prev) =>
                                    checked
                                      ? [...prev, record.ApplicationId]
                                      : prev.filter((id) => id !== record.ApplicationId)
                                  );
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    }
                  ])}
                  dataSource={buildDataSourceWithCalcRow(repaymentsData.slice(
                    (repaymentsPage - 1) * pageSize,
                    repaymentsPage * pageSize
                  ), "repayment")}
                  rowKey="ApplicationId"
                  pagination={false}
                  className="transparent-table advancesTableMain"
                  locale={{ emptyText: getTableEmptyText() }}
                  scroll={{ x: "max-content" }}
                  rowClassName={(record) => (record.__isCalcSummaryRow ? "calc-summary-row" : "")}
                />
              }

              {/* Corporate Loan -- one row per Sponser facility (one portfolio company each) */}
              {
                loanProgrameType === 4 &&
                <Table
                  columns={decorateColumnsForCalcRow([
                    { title: "Portfolio Company", dataIndex: "PortfolioCompany", render: (value) => value || "-" },
                    { title: "Facility", dataIndex: "Institution", render: (value) => value || "-" },
                    { title: "Loan Structure", dataIndex: "LoanStructure", render: (value) => value || "-" },
                    { title: "Original Facility Size", dataIndex: "OriginalFacilitySize", render: (value) => formatCurrency(value) },
                    {
                      title: (
                        <div style={{ lineHeight: 1.2 }}>
                          <div>Current Outstanding Balance</div>
                          <div style={{ fontSize: "12px" }}>As of:</div>
                        </div>
                      ),
                      dataIndex: "OutstandingBalanace",
                      render: (value) => formatCurrency(value),
                    },
                    { title: "Availability", dataIndex: "Availability", render: (value) => formatCurrency(value) },
                    { title: "Maturity Date", dataIndex: "MaturityDate", render: (value) => formatDate(value) },
                    {
                      title: "Repayment Amount",
                      dataIndex: "RepaymentAmount",
                      render: (value, record) => {
                        const editable = isRepaymentEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRepaymentRow.RepaymentAmount}
                            onChange={(val) =>
                              setEditingRepaymentRow({ ...editingRepaymentRow, RepaymentAmount: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Post-Repayment Availability", dataIndex: "PostRepaymentAvailability", render: (value) => formatCurrency(value) },
                    { title: "Validation Result", dataIndex: "ValidationResult", render: (value) => value || "-" },
                    {
                      title: "Action",
                      fixed: "right",
                      width: 170,
                      render: (_, record) => {
                        const editable = isRepaymentEditing(record);
                        return editable ? (
                          <div className="actionColumnDiv">
                            <Tooltip title="Calculation Summary">
                              <Button type="link" loading={previewLoading} onClick={handlePreviewRepaymentClick}
                                icon={<img src="/calculator.png.png" alt="Calculate" style={{ width: 16, height: 16 }} />}
                              />
                            </Tooltip>
                            <Tooltip title="Cancel">
                              <Button type="link" onClick={cancelRepaymenthandleClick}
                                icon={<CloseOutlined />}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="actionColumnDiv">
                            <Tooltip title="Edit">
                              <Button type="link" onClick={() => editRepaymenthandleClick(record)}
                                icon={<EditTwoTone />}
                              />
                            </Tooltip>
                            <Tooltip title="History">
                              <Button type="link" onClick={() => handleViewBatchHistory("Repayment", record.SponserId)}
                                icon={<EyeOutlined />}
                              />
                            </Tooltip>
                            <span
                              style={{
                                display: "inline-flex",
                                width: 45,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                checked={selectedRepaymentRowKeys.includes(record.ApplicationId)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setSelectedRepaymentRowKeys((prev) =>
                                    checked
                                      ? [...prev, record.ApplicationId]
                                      : prev.filter((id) => id !== record.ApplicationId)
                                  );
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    }
                  ])}
                  dataSource={buildDataSourceWithCalcRow(repaymentsData.slice(
                    (repaymentsPage - 1) * pageSize,
                    repaymentsPage * pageSize
                  ), "repayment")}
                  rowKey="ApplicationId"
                  pagination={false}
                  className="transparent-table advancesTableMain"
                  locale={{ emptyText: getTableEmptyText() }}
                  scroll={{ x: "max-content" }}
                  rowClassName={(record) => (record.__isCalcSummaryRow ? "calc-summary-row" : "")}
                />
              }
              {
                loanProgrameType !== 2 && loanProgrameType !== 4 &&
                <Table
                  columns={decorateColumnsForCalcRow([
                    { title: "Client Name", dataIndex: "BorrowerName" },
                    { title: "Facility Reference", dataIndex: "AccountNumber" },
                    {
                      title: "Loan Amount",
                      dataIndex: "LoanAmount",
                      render: (value) => value || "-"
                    },

                    {
                      title: (
                        <div style={{ lineHeight: 1.2 }}>
                          <div>Outstanding</div>
                          <div style={{ fontSize: "12px" }}>
                            As of:
                          </div>
                        </div>
                      ),
                      dataIndex: "OutstandingBalanace",
                      render: (value) => value || "-"
                    },
                    { title: "Availability", dataIndex: "Availability" },
                    // Fair Market Value intentionally hidden from the Repayment grid (UI-only) —
                    // still fully present in editingRepaymentRow state, the Preview/Save payloads,
                    // and the backend calculation; it's simply not rendered as a column here.
                    // Gross Repayment: editable, persisted via Applicant.GrossRePayment (Save/Preview both
                    // wired to the real field — see savehandleRepaymentsClick/handlePreviewRepaymentClick).
                    {
                      title: "Gross Repayment ",
                      dataIndex: "GrossRePayment",
                      render: (value, record) => {
                        const editable = isRepaymentEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRepaymentRow.GrossRePayment}
                            onChange={(val) =>
                              setEditingRepaymentRow({ ...editingRepaymentRow, GrossRePayment: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          value ? formatCurrency(value) : "-"
                        );
                      },
                    },
                    {
                      title: "Cost Basis ",
                      dataIndex: "CostBasis",
                      render: (value, record) => {
                        const editable = isRepaymentEditing(record);

                        return editable ? (
                          <CurrencyInput
                            value={editingRepaymentRow.CostBasis}
                            onChange={(val) =>
                              setEditingRepaymentRow({ ...editingRepaymentRow, CostBasis: val })
                            }
                            style={{ width: "100%" }}
                          />
                        ) : (
                          formatCurrency(value)
                        );
                      },
                    },
                    { title: "Sweep %", dataIndex: "SweepPercentage", render: (value) => value || "-" },
                    { title: "Tax Rate ", dataIndex: "TaxRate" },
                    {
                      title: "Gains ",
                      dataIndex: "Gains",
                      render: (value) => formatCurrency(value),
                    },
                    { title: "Tax", dataIndex: "Tax" },
                    { title: "Repayment Basis Amount", dataIndex: "RepaymentBasisAmount" },
                    {
                      title: "Repayment Amount",
                      dataIndex: "RepaymentAmount",
                      render: (value) => formatCurrency(value),
                    },
                    {
                      title: (
                        <div>
                          Post-Repayment <br />
                          Outstanding
                        </div>
                      ),
                      dataIndex: "PostRepaymentOutstanding",
                    },
                    { title: "Post-Repayment Availability", dataIndex: "PostRepaymentAvailability", },
                    {
                      title: (
                        <div>
                          Post-Repayment <br />
                          LTV
                        </div>
                      ),
                      dataIndex: "PostRepaymentLTV",
                    },
                    { title: "Repayment ", dataIndex: "RePayment" },
                    { title: "Net Repayment ", dataIndex: "NetPayment" },
                    { title: "Fund(s)", dataIndex: "FundPledges", render: (value) => value || "-" },
                    {
                      title: "Action",
                      fixed: "right",
                      render: (_, record) => {
                        const editable = isRepaymentEditing(record);
                        return editable ? (
                          <div className="actionColumnDiv">
                            <Tooltip title="Calculation Summary">
                              <Button type="link" loading={previewLoading} onClick={handlePreviewRepaymentClick}
                                icon={<img src="/calculator.png.png" alt="Calculate" style={{ width: 16, height: 16 }} />}
                              />
                            </Tooltip>
                            <Tooltip title="Cancel">
                              <Button type="link" onClick={cancelRepaymenthandleClick}
                                icon={<CloseOutlined />}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="actionColumnDiv">
                            <Tooltip title="Edit">
                              <Button type="link" onClick={() => editRepaymenthandleClick(record)}
                                icon={<EditTwoTone />}
                              />
                            </Tooltip>
                            {/* <Tooltip title="History">
                              <Button type="link" onClick={() => handleRepaymentHistoryClick(record)}
                                icon={<EyeOutlined />}
                              />
                            </Tooltip> */}
                            <span
                              style={{
                                display: "inline-flex",
                                width: 45,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                checked={selectedRepaymentRowKeys.includes(record.ApplicationId)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setSelectedRepaymentRowKeys((prev) =>
                                    checked
                                      ? [...prev, record.ApplicationId]
                                      : prev.filter((id) => id !== record.ApplicationId)
                                  );
                                }}
                              />
                            </span>
                          </div>
                        );
                      },
                    }
                  ])}
                  dataSource={buildDataSourceWithCalcRow(repaymentsData.slice(
                    (repaymentsPage - 1) * pageSize,
                    repaymentsPage * pageSize
                  ), "repayment")}
                  rowKey="ApplicationId"
                  pagination={false}
                  className="transparent-table advancesTableMain"
                  locale={{ emptyText: getTableEmptyText() }}
                  scroll={{ x: "max-content" }}
                  rowClassName={(record) => (record.__isCalcSummaryRow ? "calc-summary-row" : "")}
                />
              }


              <div
                className="table-footer"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <Pagination
                  current={drawsPage}
                  pageSize={pageSize}
                  total={repaymentsData.length}
                  onChange={(page) => setRepaymentsPage(page)}
                  className="pagination"
                />
                <div className="toolbar-actions">
                  <ButtonComponent
                    className="view-btn"
                    type="default"
                    text="History"
                    onClick={() => handleViewBatchHistory("Repayment")}
                  />
                  <ButtonComponent
                    className="view-btn"
                    type="default"
                    text="Download"
                    onClick={handleDownloadRepaymentsPDF}
                  />
                  <ButtonComponent
                    className="view-btn"
                    text="Send to Senior Banker"
                    onClick={() => openCertifyModal("Repayment")}
                    loading={batchSubmitting}
                  />
                </div>

              </div>
            </TabPane>
          </Tabs>
        </Spin>
        {/*   )}*/}
      </div>

      <Modal
        title={historyTab === "repayment" ? "Repayment Transaction History" : "Advance Transaction History"}
        visible={historyModalVisible}
        onCancel={closeHistoryModal}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <Spin spinning={historyLoading}>
          <Table
            dataSource={historyData}
            columns={getHistoryColumns(historyTab)}
            rowKey="Id"
            pagination={{ pageSize: 5 }}
            className="transparent-table"
            scroll={{ x: "max-content" }}
            locale={{ emptyText: "No history available." }}
          />
        </Spin>
      </Modal>

      <Modal
        title={batchHistoryType === "Repayment" ? "Repayment Batch History" : "Advance Batch History"}
        visible={batchHistoryModalVisible}
        onCancel={closeBatchHistoryModal}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <Spin spinning={batchHistoryLoading}>
          <Table
            dataSource={batchHistoryData.slice(
              (batchHistoryPage - 1) * pageSize,
              batchHistoryPage * pageSize
            )}
            columns={getBatchHistoryColumns()}
            rowKey={(record, index) => record.Id ?? index}
            pagination={false}
            className="transparent-table batch-history-table"
            scroll={{ x: "max-content" }}
            locale={{ emptyText: "No batch history available." }}
          />
          {batchHistoryData.length > 0 && (
            <div className="table-footer" style={{ justifyContent: "flex-end", marginTop: 16 }}>
              <Pagination
                current={batchHistoryPage}
                pageSize={pageSize}
                total={batchHistoryData.length}
                onChange={(page) => setBatchHistoryPage(page)}
                className="pagination"
              />
            </div>
          )}
        </Spin>
      </Modal>

      <Modal
        title="Certify & Submit Batch"
        visible={certifyModalVisible}
        onCancel={closeCertifyModal}
        footer={null}
        width={600}
        destroyOnClose
      >
        <div style={{ color: "#f4f4f5" }}>
          I, <b>{submittedByName.trim() || "[Name]"}</b>, attest that I am authorized to submit
          this advance/repayment on behalf of the institution. I have reviewed the transaction and
          confirm that the details and calculated amounts are accurate and consistent with the
          approved facility terms. I understand this submission is final, recorded, and subject to
          audit.
        </div>
        <Form form={certifyForm} layout="vertical">
          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Name"
                name="submittedByName"
                rules={[{ required: true, message: "Name is required" }]}
              >
                <Input
                  placeholder="Enter your name"
                  onChange={(e) => setSubmittedByName(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Date & Time" name="submittedDateDisplay">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24 }}>
          <Button onClick={closeCertifyModal}>Cancel</Button>
          <Button type="primary" loading={batchSubmitting} onClick={handleCertifyModalSubmit}>
            Submit
          </Button>
        </div>
      </Modal>

    </SidebarLayout>

  );
};

export default AdvancesAndRepayments;

